import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { validateConfig } from '@angular/router/src/config';
@Component({
  selector: 'app-profile-popup',
  templateUrl: './profile-popup.component.html',
  styleUrls: ['./profile-popup.component.css'],

})
export class ProfilePopupComponent implements OnInit {
  @Input( ) title : any
  data: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  oldimage: string;
  imgError: string;
  @ViewChild('contentProfile') modal: ElementRef;
  modalRef: NgbModalRef;
  @Output() setEvent = new EventEmitter();
  constructor(
    private modalService: NgbModal
  ) {
  }

  ngOnInit() {

  }

  showModal(image) {
    this.oldimage = image;
    // this.toDataURL(image, function (dataUrl) {
    this.modalRef = this.modalService.open(this.modal, { windowClass: 'profile-modal' });
  }

  setImage(img) {
    this.setEvent.emit(img);
  }
  closeModal() {
    this.modalRef.close();
  }


  fileChangeEvent(event: any): void {
    const file = event.target.files[0];
    if (file) {
      if (this.validateFile(file.type)) {
        this.imgError = '';
        this.imageChangedEvent = event;
      } else {
        this.imgError = 'Please select only Images.';
        this.imageChangedEvent = '';
      }
    }
  }
  imageCropped(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    // show cropper
  }
  loadImageFailed() {
    // show message
  }
  validateFile(filetype: String) {
    if (filetype === 'image/png' || filetype === 'image/jpg' || filetype === 'image/jpeg') {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-popup/profile-popup/profile-popup.component.ts